import { useRequest } from "hooks";
import type { ThunkReturnType } from "types";
import { ApiRouteTypes } from "consts/enpoints/api";
import useExportTable from "hooks/useExportTable";
import type { PhoneVerificationsResponse } from "../types";
import { getPhoneVerificationsThunk } from "../thunks";
import { changeExportPhoneVerificationsLoading as changeExportLoading } from "../slice";

export const usePhoneVerificationsActions = () => {
    const getPhoneVerifications = useRequest<
        ThunkReturnType<PhoneVerificationsResponse>,
        string | undefined
    >({
        thunk: getPhoneVerificationsThunk
    });

    const downloadCsv = useExportTable({
        changeExportLoading,
        apiResourceType: ApiRouteTypes.GetPhoneVerifications
    });

    return {
        getPhoneVerifications,
        downloadCsv
    };
};

export default usePhoneVerificationsActions;
